import React from "react";
import { motion } from "framer-motion";
import {
  UserPlusIcon,
  PencilSquareIcon,
  PhotoIcon,
} from "@heroicons/react/24/solid";

const HowItWorks = () => {
  return (
    <section className="px-4 xl:px-0 py-16 bg-white">
      <div className="text-center mb-12">
        <span className="px-4 py-1 bg-indigo-600 text-white rounded-full uppercase text-xs tracking-widest">
          Work Process
        </span>
        <h2 className="text-4xl font-bold mt-4">How It Works</h2>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-12 md:gap-8 mb-16">
        {[
          {
            title: "Step 1: Create Account",
            icon: <UserPlusIcon className="h-8 w-8 text-white" />,
          },
          {
            title: "Step 2: Type Context",
            icon: <PencilSquareIcon className="h-8 w-8 text-white" />,
          },
          {
            title: "Step 3: Get Images",
            icon: <PhotoIcon className="h-8 w-8 text-white" />,
          },
        ].map((step, index) => (
          <motion.div
            key={index}
            className="flex flex-col items-center text-center max-w-xs"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#4f46e5] mb-4">
              {step.icon}
            </div>
            <h2 className="">{step.title}</h2>
            <p className="text-gray-500 mt-2">
              Easily create your Zaplin account with one click and get 100
              Million Tokens.
            </p>
          </motion.div>
        ))}
      </div>

      {/* Video Section */}
      {/* <div className="container mx-auto">
        <video
          className="w-4/5 mx-auto rounded-lg shadow-lg"
          controls
          src="/your-video.mp4"
        >
          Your browser does not support the video tag.
        </video>
      </div> */}
      
      {/* Geçici dummy video */}
      <div className="container mx-auto">
        <div className="w-4/5 mx-auto aspect-video rounded-lg shadow-lg overflow-hidden">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/D0UnqGm_miA"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
